export default __webpack_public_path__ + "static/media/orders.10dd89e3.svg";